import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { Milliseconds } from '@/utils/milliseconds'

type Props = {
  createdAt: Date
  status: string
}

export default function Component({ status, createdAt }: Props) {
  const isFinished =
    ['DONE', 'CLOSED', 'CANCELED'].find((ea) => ea === status) !== undefined
  if (isFinished) return null

  const expireTime = new Date(createdAt).getTime() + Milliseconds({ hours: 72 })
  const remainingTime = Math.floor(
    (expireTime - new Date().getTime()) / Milliseconds({ hours: 1 }),
  )
  const colorClassName =
    remainingTime > 24
      ? 'bg-primary'
      : remainingTime > 12
        ? 'bg-yellow-500'
        : 'bg-red-500'

  return remainingTime > 0 ? (
    <div className="flex items-center gap-2">
      <span>{remainingTime}h</span>
      <div className="h-2 flex-1 overflow-hidden rounded-sm bg-black/10">
        <div
          className={cn('h-full', colorClassName)}
          style={{ width: `${Math.min((remainingTime / 72) * 100, 100)}%` }}
        />
      </div>
    </div>
  ) : (
    <Badge className="border-transparent bg-red-500 text-white">Expirado</Badge>
  )
}
